import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-1', 'IconNumber1', [["path",{"d":"M13 20v-16l-5 5","key":"svg-0"}]]);